import type { Notification } from "@/domain";

/**
 * Generates navigation link for notification's related entity
 */
export const getNotificationLink = (
	notification: Notification,
): string | null => {
	if (!notification.related_entity_type || !notification.related_entity_uuid) {
		return null;
	}

	switch (notification.related_entity_type) {
		case "project":
			return `/projects/${notification.related_entity_uuid}`;
		case "investment":
			return `/investments/main?investment=${notification.related_entity_uuid}`;
		case "document":
			return `/investments/contracts?document_uuid=${notification.related_entity_uuid}`;
		default:
			return null;
	}
};
